import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getCollectionReport=({
    startDate,
    endDate,
    type
})=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_COLLECTION_REPORT_START,
    })
    await axios.get(`/reports/agents/daily?startDate=${startDate}&endDate=${endDate}&type=${type}`)
            .then(response=>dispatch({
                type:actionTypes.GET_COLLECTION_REPORT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_COLLECTION_REPORT_FAIL,
                payload:getMessage(error)
            }))
}